import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  profile: defineAsyncComponent(() => import("/app/layouts/profile.vue").then(m => m.default || m))
}